var _g, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M46.496,24c0,0.098,0,0.195-0.012,0.293c-0.016,1.961-0.289,3.934-0.84,5.809 c-0.496,1.906-1.297,3.715-2.32,5.395c-0.996,1.699-2.207,3.258-3.629,4.609c-1.395,1.383-2.984,2.57-4.707,3.523 c-1.711,0.965-3.547,1.695-5.453,2.18c-1.902,0.48-3.863,0.715-5.836,0.688c-1.961-0.012-3.922-0.305-5.812-0.855 c-1.891-0.508-3.711-1.297-5.395-2.305c-1.683-0.992-3.242-2.223-4.609-3.641c-1.379-1.395-2.571-2.984-3.508-4.707 c-0.977-1.711-1.711-3.547-2.18-5.453c-0.496-1.902-0.73-3.863-0.691-5.836c0.016-1.961,0.293-3.922,0.844-5.813 c0.523-1.891,1.297-3.711,2.32-5.395C5.66,10.809,6.887,9.25,8.293,7.883C9.707,6.5,11.289,5.312,13,4.375 c1.715-0.98,3.551-1.711,5.457-2.18c1.902-0.496,3.875-0.73,5.832-0.691c1.961,0.016,3.922,0.289,5.813,0.844 c1.891,0.523,3.715,1.297,5.398,2.316c1.699,0.996,3.258,2.227,4.609,3.633c1.379,1.406,2.566,2.996,3.52,4.703 c0.965,1.715,1.695,3.551,2.164,5.469C46.281,20.262,46.516,22.137,46.496,24"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "27.129,27.223 21.328,34.773 15.531,27.223 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8753,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "27.129,27.223  21.328,34.773 15.531,27.223 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5.2446,
    d: "M21.211,26.996c-0.059-3.004,1.098-5.898,3.203-8.039 c2.109-2.137,4.988-3.332,7.988-3.316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnOpen);
export default __webpack_public_path__ + "static/media/btnOpen.a479af9b01023c8551109f8ad946c697.svg";
export { ForwardRef as ReactComponent };